import React, { useEffect, useState } from 'react'
//import ModalLiquidacionProcedimientoCirugia from './ModalLiquidacionProcedimientoCirugia'
import ModalValidacionFacturada from './ModalValidacionFacturada'
import ModalLiquidarLosProcedimientosQx from './ModalLiquidarLosProcedimientosQx'
import { getObtenerTodasOpcionesCirugia } from '../../../services/PaginaRuta'
import ModalProcedimientoPaqueteLiquidacion from './ModalProcedimientoPaqueteLiquidacion'
import ModalInconsistenciasEnLiquidacionQx from './ModalInconsistenciasEnLiquidacionQx'
import ModalProcedimientosFaltantesPortafolioLiquidacion from './ModalProcedimientosFaltantesPortafolioLiquidacion'
import ModalLiquidarPaquetesYFormasLiquidacion from './ModalLiquidarPaquetesYFormasLiquidacion'

const TablaLiquidacionQx = ({item,setactualizarDataLiquidacion}) => {
  const [modalOnLiquidacion, setmodalOnLiquidacion]=useState(false)
  const [modalOnValidacionFacturada, setmodalOnValidacionFacturada]=useState(false)
  const [dataOpcionCirugia, setdataOpcionCirugia]=useState([])
  const [modalOnPaqueteProcedimientos, setmodalOnPaqueteProcedimientos]=useState(false)
  const [modalOnInconsistencia, setmodalOnInconsistencia]=useState(false)
  const [modalOnProcedimientosFaltantesPortafolio, setmodalOnProcedimientosFaltantesPortafolio]=useState(false)
  const [modalOnLiquidacionPaquetesYFormas, setmodalOnLiquidacionPaquetesYFormas]=useState(false)
  //const [arrayProcedimientosFaltantes, setarrayProcedimientosFaltantes]=useState([])

  const handleOnclickProcedimientoCirugia=()=>{
    console.log(Object.values(item.ProcedimientosFaltantes), 'ProcedimientosFaltantes antes')
    
      if(item.ProcedimientosFaltantes.length === 0){
        //procedimientos de cirugia
        const procedimientos = item.Procedimientos;
        //validar que todos los del array sean igual a S de tipo paquete      
        const validarPaquete = procedimientos.every(procedimiento => procedimiento.PTIndPaq === 'S' );
        //validar que todos lo del array tengan informacion de formas de liquidacion
        const validarFormasLiquidacion = procedimientos.every(item => typeof item.ForLiqCod === 'string' && item.ForLiqCod.trim().length > 0);
        //validar que los procedimientos tengan paquete o formas de liquidacion, pero no las dos al mismo tiempo
        const validarPaqueteOFormasLiquidacion = procedimientos.some(item => item.PTIndPaq === 'S' && item.ForLiqCod && item.ForLiqCod.trim().length > 0);
        //validar si algun procedimiento le falta paquete o formas de liquidacion
        const validarVacioPaqueteOFormasLiquidacion = procedimientos.some(item => item.PTIndPaq === 'N' && item.ForLiqCod == null);
        
        
        //empiezanado de validacion de inconsistencias
        if(parseInt(item.ProEsta) === 5){
          setmodalOnValidacionFacturada(true)
        }
        else if(validarPaqueteOFormasLiquidacion || validarVacioPaqueteOFormasLiquidacion){
          setmodalOnInconsistencia(true)
        }
        else if(validarPaquete){
          setmodalOnPaqueteProcedimientos(true)
        }else if(validarFormasLiquidacion){
          setmodalOnLiquidacion(true)
        }else{          
          setmodalOnLiquidacionPaquetesYFormas(true)
        }
      }else{
        //console.log('no hay ProcedimientosFaltantes')
        //setarrayProcedimientosFaltantes(Object.values(item.ProcedimientosFaltantes))
        setmodalOnProcedimientosFaltantesPortafolio(true)
      }
      /////////////////////termina////////////////////
    //setmodalOnPaqueteProcedimientos(true)
    // if(item.ProEsta === '5'){
    //   setmodalOnValidacionFacturada(true)
    // }else{
    //   setmodalOnLiquidacion(true)
    // }
    
  }

  useEffect(()=>{
    getObtenerTodasOpcionesCirugia().then((res)=>{ 
      console.log(res.data.data)
      setdataOpcionCirugia(res.data.data)
    })
  },[])

  return (
    <tbody>
    <tr className="divide-y divide-slate-700">
        <td></td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
          <button type="button"
                onClick={handleOnclickProcedimientoCirugia}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Seleccionar
              </button>
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
          {item.ProFec? item.ProFec.split(' ')[0]:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4 whitespace-pre-wrap">
           {item.ProCons? item.ProCons:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {item.ConsDet? item.ConsDet:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {item.MPTDoc? item.MPTDoc:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {item.MPCedu? item.MPCedu:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap text-left">
            {item.MPNOMC? item.MPNOMC:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {item.ProHorI? item.ProHorI:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {item.ProHorF? item.ProHorF:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {parseInt(item.ProEsta) === 5? 'Facturado':(item.ultimoEstado === 'salida'? 'Salida':(parseInt(item.ProEsta) === 4? 'Realizado':null))}
            
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-4  whitespace-pre-wrap">
            {/* {item.ProEsta? item.ProEsta:null} */}
            {item.CNCCOD? item.CNCCOD:null}
          </td>
          
        </tr>
        {modalOnLiquidacion?<ModalLiquidarLosProcedimientosQx setmodalOnLiquidacion={setmodalOnLiquidacion} item={item} setactualizarDataLiquidacion={setactualizarDataLiquidacion} dataOpcionCirugia={dataOpcionCirugia}/>:null}
        {modalOnLiquidacionPaquetesYFormas?<ModalLiquidarPaquetesYFormasLiquidacion setmodalOnLiquidacion={setmodalOnLiquidacionPaquetesYFormas} item={item} setactualizarDataLiquidacion={setactualizarDataLiquidacion} dataOpcionCirugia={dataOpcionCirugia}/>:null}
        {modalOnValidacionFacturada? <ModalValidacionFacturada setmodalOnValidacionFacturada={setmodalOnValidacionFacturada}/>:null}
        {modalOnPaqueteProcedimientos? <ModalProcedimientoPaqueteLiquidacion setmodalOnPaqueteProcedimientos={setmodalOnPaqueteProcedimientos} item={item} setactualizarDataLiquidacion={setactualizarDataLiquidacion} dataOpcionCirugia={dataOpcionCirugia}/>:null}
        {modalOnInconsistencia && <ModalInconsistenciasEnLiquidacionQx dataProcedimientos={item.Procedimientos} setmodalOnInconsistencia={setmodalOnInconsistencia} item={item}/>}
        {modalOnProcedimientosFaltantesPortafolio && <ModalProcedimientosFaltantesPortafolioLiquidacion setmodalOnProcedimientosFaltantesPortafolio={setmodalOnProcedimientosFaltantesPortafolio} arrayProcedimientosFaltantes={Object.values(item.ProcedimientosFaltantes)} codigoPortafolio={item.PTCodi}/>}
        </tbody>
  )
}

export default TablaLiquidacionQx